import { useMemo } from "react";
import { translations } from "../../../utils/lang";
import './crmSummary.css'

const STATUS_ENUM = [
  "new",
  "in_progress",
  "potential",
  "trial_active",
  "quote_sent",
  "active",
  "inactive",
];

const FOLLOWUP_ENUM = ["asap", "urgent", "date", "waiting"];

export default function CRMSummary({ filteredData, lang }) {
  const crmSummary = useMemo(() => {
    const summary = {
      total: 0,
      status: {},
      followUp: {},
    };

    // initialize ALL statuses (important — avoid missing keys in UI)
    STATUS_ENUM.forEach((s) => (summary.status[s] = 0));
    FOLLOWUP_ENUM.forEach((s) => (summary.followUp[s] = 0));

    filteredData.forEach((item) => {
      summary.total++;

      const status = item.crm?.status;
      const follow = item.crm?.dateStatus || "asap";

      if (status && summary.status[status] !== undefined) {
        summary.status[status]++;
      }

      if (summary.followUp[follow] !== undefined) {
        summary.followUp[follow]++;
      }
    });

    return summary;
  }, [filteredData]);
  return (
    <div className="crm-summary">
        <div className="summary-grid">
            <div className={`summary-card follow total`}>
              <span>{translations[lang].crm.total}:</span>
              <strong>{crmSummary.total}</strong>
            </div>

          {Object.entries(crmSummary.status).map(([key, value]) => (
            <div key={key} className={`summary-card status ${key}`}>
              <span>
                {translations[lang].restaurants.restaurantsRow.status[key]}
              </span>
              <strong>{value}</strong>
            </div>
          ))}
          {Object.entries(crmSummary.followUp).map(([key, value]) => (
            <div key={key} className={`summary-card follow ${key}`}>
              <span>{translations[lang].crm.dateStatus[key]}</span>
              <strong>{value}</strong>
            </div>
          ))}
        </div>
    </div>
  );
}
